/**
 * Utility function to normalize styles and prevent conflicts between
 * shorthand and non-shorthand CSS properties
 *
 * React Native warns when mixing properties like:
 * - borderRadius with borderTopLeftRadius, etc.
 * - borderColor with borderTopColor, etc.
 * - borderWidth with borderTopWidth, etc.
 * - borderStyle with borderTopStyle, etc.
 */
export const normalizeStyles = (styles: any): any => {
	if (!styles || typeof styles !== 'object') return styles;

	const normalized = { ...styles };

	// Handle borderRadius conflicts
	if (
		normalized.borderRadius &&
		(normalized.borderTopLeftRadius ||
			normalized.borderTopRightRadius ||
			normalized.borderBottomLeftRadius ||
			normalized.borderBottomRightRadius)
	) {
		// If specific border radius properties exist, remove shorthand
		delete normalized.borderRadius;
	}

	// Handle borderColor conflicts
	if (
		normalized.borderColor &&
		(normalized.borderTopColor ||
			normalized.borderRightColor ||
			normalized.borderBottomColor ||
			normalized.borderLeftColor)
	) {
		// If specific border colors exist, remove shorthand
		delete normalized.borderColor;
	}

	// Handle borderWidth conflicts
	if (
		normalized.borderWidth &&
		(normalized.borderTopWidth ||
			normalized.borderRightWidth ||
			normalized.borderBottomWidth ||
			normalized.borderLeftWidth)
	) {
		// If specific border widths exist, remove shorthand
		delete normalized.borderWidth;
	}

	// Handle borderStyle conflicts
	if (
		normalized.borderStyle &&
		(normalized.borderTopStyle ||
			normalized.borderRightStyle ||
			normalized.borderBottomStyle ||
			normalized.borderLeftStyle)
	) {
		// If specific border styles exist, remove shorthand
		delete normalized.borderStyle;
	}

	return normalized;
};

/**
 * Merge multiple style objects and normalize to prevent conflicts
 */
export const mergeAndNormalizeStyles = (...styleObjects: any[]): any => {
	const merged = Object.assign({}, ...styleObjects.filter(Boolean));
	return normalizeStyles(merged);
};
